import { render, staticRenderFns } from "./BoardColumn.vue?vue&type=template&id=6bccc449&scoped=true&"
import script from "./BoardColumn.vue?vue&type=script&lang=js&"
export * from "./BoardColumn.vue?vue&type=script&lang=js&"
import style0 from "./BoardColumn.vue?vue&type=style&index=0&id=6bccc449&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bccc449",
  null
  
)

export default component.exports